export default {
  API_URL: process.env.NEXT_PUBLIC_API_URL ?? 'https://api.trucksmarter.com',
  // USE_API_PROXY set to "true" enables the local API development proxy. It
  // should be be turned off in production and staging.
  USE_API_PROXY: process.env.NEXT_PUBLIC_USE_API_PROXY === 'true',
  ENABLE_DATADOG_LOGGING:
    process.env.NEXT_PUBLIC_ENABLE_DATADOG_LOGGING === 'true',
  DATADOG_CLIENT_TOKEN: process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN,
  ENABLE_CONSOLE_LOGS: process.env.NEXT_PUBLIC_ENABLE_CONSOLE_LOGS === 'true',
  LAUNCHDARKLY_CLIENT_ID: process.env.NEXT_PUBLIC_LAUNCHDARKLY_CLIENT_ID,
  SENTRY_ENABLED: process.env.NEXT_PUBLIC_SENTRY_ENABLED === 'true',
  SEGMENT_WRITE_KEY: process.env.NEXT_PUBLIC_SEGMENT_WRITE_KEY,
  SEGMENT_UNMINIFIED: process.env.NEXT_PUBLIC_SEGMENT_UNMINIFIED === 'true',
  WAF_SCRIPT_URL: process.env.NEXT_PUBLIC_WAF_SCRIPT_URL,
  APP_NAME_UNAUTHED_ENDPOINT_OVERRIDE:
    process.env.NEXT_PUBLIC_APP_NAME_UNAUTHED_ENDPOINT_OVERRIDE,
  OAUTH_SIGNUP_URL_GOOGLE: process.env.NEXT_PUBLIC_OAUTH_SIGNUP_URL_GOOGLE,
  OAUTH_URL_GOOGLE: process.env.NEXT_PUBLIC_OAUTH_URL_GOOGLE,
  OAUTH_URL_YAHOO: process.env.NEXT_PUBLIC_OAUTH_URL_YAHOO,
  OAUTH_URL_APPLE: process.env.NEXT_PUBLIC_OAUTH_URL_APPLE,
  STYTCH_TOKEN: process.env.NEXT_PUBLIC_STYTCH_TOKEN,
  STYTCH_TELEMETRY_SCRIPT_URL:
    process.env.NEXT_PUBLIC_STYTCH_TELEMETRY_SCRIPT_URL,
  COMMIT_SHA: process.env.NEXT_PUBLIC_COMMIT_SHA,
  STRIPE_PUBLISHABLE_KEY: process.env.NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY,
  CLEVERTAP_ACCOUNT_ID: process.env.NEXT_PUBLIC_CLEVERTAP_ACCOUNT_ID,
  CLEVERTAP_TOKEN: process.env.NEXT_PUBLIC_CLEVERTAP_TOKEN,
} as const;
